// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__21Jy0","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1q9ui"};